import _CircleOutline from '@lyearn/icons/dist/cjs/web/CircleOutline';
import _CheckboxFill from '@lyearn/icons/dist/cjs/web/CheckboxFill';
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React__default from 'react';
import c from 'classnames';
import { checkBoxStyles, circularCheckBoxFocusStyles } from './utils/styles.js';
import BaseCheckbox from '@mui/material/Checkbox';
import { CHECK_SIZE_CLASSES } from './utils/index.js';

var _excluded = ["className", "size"];
var CircularCheckbox = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var className = props.className,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var sizeClasses = CHECK_SIZE_CLASSES[size];
  return /*#__PURE__*/React__default.createElement(BaseCheckbox, _extends({
    ref: ref,
    disableRipple: true,
    checkedIcon: /*#__PURE__*/React__default.createElement(_CheckboxFill, {
      className: c('rounded-full', sizeClasses)
    }),
    className: c('p-0', className, checkBoxStyles, circularCheckBoxFocusStyles),
    icon: /*#__PURE__*/React__default.createElement(_CircleOutline, {
      className: sizeClasses
    })
  }, rest));
});
var CircularCheckbox$1 = /*#__PURE__*/React__default.memo(CircularCheckbox);

export { CircularCheckbox$1 as default };
//# sourceMappingURL=CircularCheckbox.js.map
